import React, { useEffect, useState } from "react";
import axios from "axios";
import { backend_url } from "../App";
import "./CSS/varietyAccessories.css";
import { menuItems } from "../Constants/menuItems";
import { isAdmin } from "../utils/roleUtils";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const TopSellersRetro = () => {
  const [topSellersRetro, setTopSellersRetro] = useState([]);
  const [formData, setFormData] = useState({
    collectionName: "",
    category: "",
    routeTo: "",
    image: null,
    placeTo: "",
    productId: "",
  });
  const [allProducts, setAllProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [loading, setLoading] = useState(false);

  // Fetch all topsellers
  useEffect(() => {
    fetchTopsellersRetro();
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${backend_url}/allproducts`);
      console.log("Fetched products:", response.data);
      setAllProducts(response.data);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const filteredProducts = allProducts.filter((product) => {
    const isCategoryMatch = product.category === formData.category;
    const isSubcategoryMatch = product.subcategory === formData.routeTo;

    console.log(
      "Category match:",
      isCategoryMatch,
      "Subcategory match:",
      isSubcategoryMatch
    );

    return isCategoryMatch && isSubcategoryMatch;
  });

  console.log("Filtered products:", filteredProducts);

  const fetchTopsellersRetro = async () => {
    try {
      const response = await axios.get(`${backend_url}/api/topsellerretro`);
      setTopSellersRetro(response.data);
    } catch (error) {
      console.error("Error fetching TopsellersRetro:", error);
    }
  };

  // Handle form input change
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "video") {
      setFormData({ ...formData, video: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }

    if (name === "routeTo") {
      fetchProducts(formData.category, value);
    }
  };

  // Handle category change and filter route options
  const handleCategoryChange = (e) => {
    const selected = e.target.value;
    setSelectedCategory(selected);
    setFormData({ ...formData, category: selected });

    if (selected) {
      const selectedCategory = menuItems.find(
        (item) => item.value === selected
      );

      if (selectedCategory && selectedCategory.dropdown) {
        const options = selectedCategory.dropdown.flatMap((item) => {
          if (item.value === null) {
            return [
              { label: `-- ${item.label} --`, value: null },
              ...(item.subcategories || []),
            ];
          } else {
            return item;
          }
        });

        setCategoryOptions(options);
      } else {
        setCategoryOptions([]);
      }
    } else {
      setCategoryOptions([]);
    }
  };

  // Add or update variety
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.collectionName ||
      !formData.routeTo ||
      !formData.placeTo ||
      !formData.category
    ) {
      toast.error("Please fill in all required fields");
      return;
    }

    // Validation for image size (max 1MB)
    if (formData.video && formData.video.size > 20 * 1024 * 1024) {
      toast.error("Video size should be less than 20MB");
      return;
    }

    const data = new FormData();
    data.append("collectionName", formData.collectionName);
    data.append("routeTo", formData.routeTo);
    data.append("video", formData.video);
    data.append("placeTo", formData.placeTo);
    data.append("category", formData.category);
    data.append("productId", formData.productId);

    try {
      setLoading(true);
      if (editingId) {
        await axios.put(`${backend_url}/api/topsellerretro/${editingId}`, data);
      } else {
        await axios.post(`${backend_url}/api/topsellerretro`, data);
      }
      fetchTopsellersRetro();
      toast.success("Collection added Successfully");
      closeModal();
    } catch (error) {
      toast.error("Error saving topsellers/retro ");
      console.error("Error saving topsellers/retro", error);
    } finally {
      setLoading(false); // ✅ Stop loading
    }
  };

  // Handle edit
  const handleEdit = (topsellerretro) => {
    setFormData({
      collectionName: topsellerretro.collectionName,
      routeTo: topsellerretro.routeTo,
      video: topsellerretro.video,
      productId: topsellerretro.productId?._id || topsellerretro.productId,
      placeTo: topsellerretro.placeTo,
      category: topsellerretro.category,
    });

    setSelectedCategory(topsellerretro.category);

    // Fix dropdown options
    const selectedCategory = menuItems.find(
      (item) => item.value === topsellerretro.category
    );

    if (selectedCategory && selectedCategory.dropdown) {
      const options = selectedCategory.dropdown.flatMap((item) => {
        if (item.value === null) {
          return [
            { label: `-- ${item.label} --`, value: null },
            ...(item.subcategories || []),
          ];
        } else {
          return item;
        }
      });

      setCategoryOptions(options);
    } else {
      setCategoryOptions([]);
    }

    setEditingId(topsellerretro._id);
    setShowModal(true);
  };

  // Handle delete
  const handleDelete = (_id) => {
    setSelectedVideoId(_id);
    setShowConfirm(true);
  };

  const confirmDelete = async (id) => {
    try {
      await axios.delete(`${backend_url}/api/topsellerretro/${id}`);
      setShowConfirm(false);
      toast.success("Deleted Successfully");
      fetchTopsellersRetro();
    } catch (error) {
      console.error("Error deleting video:", error);
    }
  };

  // Close modal and reset form
  const closeModal = () => {
    setShowModal(false);
    setEditingId(null);
    setFormData({
      collectionName: "",
      routeTo: "",
      image: null,
      placeTo: "",
      category: "",
    });
    setSelectedCategory("");
    setCategoryOptions([]);
  };

  const formatText = (text) =>
    text.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
  return (
    <>
      <div className="variety-admin">
        <div className="headerSections">
          <div className="head-title">TopSellers/Retro Collection</div>
          <button className="add-btn" onClick={() => setShowModal(true)}>
            + Add Topseller/Retro
          </button>
        </div>

        {/* Popup Modal */}
        {showModal && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>
              <h2>{editingId ? "Edit Topseller" : "Add Topseller"}</h2>
              <form onSubmit={handleSubmit} className="variety-form">
                <div className="form-group">
                  <label htmlFor="collectionName">Collection Name</label>
                  <input
                    type="text"
                    id="collectionName"
                    name="collectionName"
                    value={formData.collectionName}
                    onChange={handleChange}
                    maxLength={30}
                    placeholder="Enter Collection Name"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="category">Category</label>
                  <select
                    id="category"
                    name="category"
                    value={selectedCategory}
                    onChange={handleCategoryChange}
                    required
                  >
                    <option value="">Select a category</option>
                    {menuItems.map((category) => (
                      <option key={category.value} value={category.value}>
                        {category.label}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Route To Dropdown */}
                <div className="form-group">
                  <label htmlFor="routeTo">SubCategory</label>
                  <select
                    id="routeTo"
                    name="routeTo"
                    value={formData.routeTo}
                    onChange={handleChange}
                    required
                    disabled={!selectedCategory}
                  >
                    <option value="">Select a route</option>
                    {categoryOptions.map((option) =>
                      option.value ? (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ) : (
                        <option key={option.label} value="" disabled>
                          {option.label}
                        </option>
                      )
                    )}
                  </select>
                </div>

                {/* Product Dropdown */}
                <div className="form-group">
                  <label htmlFor="productId">Product</label>
                  <select
                    id="productId"
                    name="productId"
                    value={formData.productId}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select a Product</option>
                    {filteredProducts.map((product) => (
                      <option key={product._id} value={product._id}>
                        {product.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="video">Upload Video</label>
                  <input
                    type="file"
                    id="video"
                    name="video"
                    accept="video/*"
                    onChange={handleChange}
                  />

                  {/* Show uploaded video name during edit */}
                  {editingId &&
                    formData.video &&
                    typeof formData.video === "string" && (
                      <p
                        style={{
                          marginTop: "8px",
                          fontSize: "14px",
                          color: "#555",
                        }}
                      >
                        Current Video:{" "}
                        <strong>{formData.video.split("/").pop()}</strong>
                      </p>
                    )}
                </div>

                <div className="form-group">
                  <label htmlFor="placeTo">Place To</label>
                  <select
                    id="placeTo"
                    name="placeTo"
                    value={formData.placeTo}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select a place</option>
                    <option value="Topsellers">Topsellers</option>
                    <option value="Retro Collections">Retro Collections</option>
                  </select>
                </div>
                <div className="form-buttons">
                  <div className="form-buttons">
                    <button
                      type="submit"
                      className="submit-btn"
                      disabled={loading}
                    >
                      {loading ? "Uploading..." : editingId ? "Update" : "Add"}
                    </button>
                  </div>
                  <button
                    type="button"
                    onClick={closeModal}
                    className="cancel-btn"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* List Table */}
        <table className="variety-table">
          <thead>
            <tr>
              <th>Collection Name</th>
              <th>Category</th>
              <th>Subcategory</th>
              <th>Video</th>
              <th>Place To</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {topSellersRetro.map((topsellers) => (
              <tr key={topsellers._id}>
                <td>{topsellers.collectionName}</td>
                <td>{formatText(topsellers.category)}</td>
                <td>{formatText(topsellers.routeTo)}</td>
                <td>
                  <video
                    src={`${topsellers.video}`}
                    alt={topsellers.collectionName}
                    autoPlay
                    loop
                    muted
                  />
                </td>
                <td>{topsellers.placeTo}</td>
                <td>
                  <button
                    className="edit-btn"
                    onClick={() => handleEdit(topsellers)}
                  >
                    Edit
                  </button>
                  {isAdmin() && (
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(topsellers._id)}
                    >
                      Delete
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Confirmation Popup */}
      {showConfirm && (
        <div className="confirm-popup">
          <div className="confirm-content">
            <p>Are you sure you want to delete?</p>
            <div className="popup-actions">
              <button
                onClick={() => confirmDelete(selectedVideoId)}
                className="confirm-btn"
              >
                Confirm
              </button>
              <button
                onClick={() => setShowConfirm(false)}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </>
  );
};

export default TopSellersRetro;
